module.exports = {
    scssVariables: './src/styles/SYNPLAY_ES',
    defaultLanguage: 'es_neutro',
    profileColor: {saturation: 70, brightness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}